export default "__VITE_ASSET__e5fe1ff4__"